import { Injectable } from '@angular/core';
import {
  asyncScheduler,
  BehaviorSubject,
  distinctUntilChanged,
  Observable,
  observeOn,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly isLoading$ = new BehaviorSubject<boolean>(false);

  loading(): void {
    this.isLoading$.next(true);
  }

  loaded(): void {
    this.isLoading$.next(false);
  }

  getObservable(): Observable<boolean> {
    return this.isLoading$.pipe(
      distinctUntilChanged(),
      // HTTP requests can start while Angular is checking the view. Delivering
      // the state on the next task prevents the spinner binding from changing
      // during that same change-detection pass.
      observeOn(asyncScheduler),
    );
  }
}
